var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SettingGroup',{attrs:{"title":"有効・無効"}},[_c('SettingItem',{attrs:{"label":"Bluetooth"}},[_c('ToggleSwitch',{attrs:{"disable":false},model:{value:(_vm.form.toggle.bluetoothFunction),callback:function ($$v) {_vm.$set(_vm.form.toggle, "bluetoothFunction", $$v)},expression:"form.toggle.bluetoothFunction"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }